import { FAQSection } from '../components/sections/FAQSection';
import { FreePreviewSection } from '../components/sections/FreePreviewSection';
import { GoodFitSection } from '../components/sections/GoodFitSection';
import { HeroSection } from '../components/sections/HeroSection';
import { ProcessSection } from '../components/sections/ProcessSection';
import { ProjectInquirySection } from '../components/sections/ProjectInquirySection';
import { SelectedWorkSection } from '../components/sections/SelectedWorkSection';
import { ServicesSection } from '../components/sections/ServicesSection';
import { WhyStudioSection } from '../components/sections/WhyStudioSection';
import { homeFaqs } from '../config/faq';
import { buildHomeStructuredData, JsonLd, Seo } from '../lib/seo';

export function HomePage() {
  return (
    <>
      <Seo
        title="Malev Studio — Websites Built Around How Your Business Sells"
        description="Business websites, corporate sites, B2B catalogues and RFQ, redesigns and landing pages built around real business needs."
        path="/"
      />
      <JsonLd data={buildHomeStructuredData()} />
      <HeroSection />
      <ServicesSection />
      <WhyStudioSection />
      <SelectedWorkSection />
      <GoodFitSection />
      <ProcessSection />
      <FreePreviewSection />
      <FAQSection items={homeFaqs} />
      <ProjectInquirySection />
    </>
  );
}
